import { TasksGenerator } from 'components/elearning/tasks/tasks-generator';
import { TopicStatusWithButton } from 'components/elearning/topic-status-with-button';
import { Carousel } from 'components/universal/carousel';
import Heading from 'components/universal/heading';
import { useTopic } from 'hooks/useTopic';
import { useTranslation } from 'react-i18next';

import img1 from 'assets/images/elearning/hospital-infections/img1.png';
import img2 from 'assets/images/elearning/hospital-infections/img2.png';
import img3 from 'assets/images/elearning/hospital-infections/img3.png';
import img4 from 'assets/images/elearning/hospital-infections/img4.png';
import img5 from 'assets/images/elearning/hospital-infections/img5.png';
import img1en from 'assets/images/elearning/hospital-infections/en/img1.png';
import img2en from 'assets/images/elearning/hospital-infections/en/img2.png';
import img3en from 'assets/images/elearning/hospital-infections/en/img3.png';
import img4en from 'assets/images/elearning/hospital-infections/en/img4.png';
import img5en from 'assets/images/elearning/hospital-infections/en/img5.png';
import { getMediaLanguage } from 'utils/language';

export const HospitalInfections = () => {
    const { t, i18n } = useTranslation('', {
        keyPrefix: 'elearning.handHygiene.microbiology.hospitalInfections',
    });
    const { tasks, correctAnswer, isAnswerChecked } = useTopic();

    const IMGS = {
        PL: [img1, img2, img3, img4, img5],
        ENG: [img1en, img2en, img3en, img4en, img5en],
    };

    const getImg = (imgIndex: number): string =>
        IMGS[getMediaLanguage(i18n.language)][imgIndex];

    const carouselItems = [
        { original: getImg(0) },
        { original: getImg(1) },
        { original: getImg(2) },
        { original: getImg(3) },
        { original: getImg(4) },
    ];

    return (
        <div>
            <Heading className="mb-5" headingLevel="h1" headingStyle="h3">
                {t('title')}
            </Heading>
            <Carousel items={carouselItems} />
            <div className="divider" />
            <Heading className="mb-10" headingLevel="h3">
                {t('title2')}
            </Heading>
            <TasksGenerator
                tasks={tasks}
                isChecked={isAnswerChecked}
                correctAnswer={correctAnswer}
            />
            <TopicStatusWithButton />
        </div>
    );
};
